import { Careers, CareersActionTypes, initialCareersState } from '../types';
import createAsyncReducer from '~lib/shared/redux/reducers/async-reducer';

const GetCareersReducer = createAsyncReducer<Careers>(CareersActionTypes.GET_CAREERS, initialCareersState.careers);

export default GetCareersReducer;
